import { render, staticRenderFns } from "./CommonStoreList.vue?vue&type=template&id=3728f20f&scoped=true&"
import script from "./CommonStoreList.vue?vue&type=script&lang=js&"
export * from "./CommonStoreList.vue?vue&type=script&lang=js&"
import style0 from "./CommonStoreList.vue?vue&type=style&index=0&id=3728f20f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3728f20f",
  null
  
)

export default component.exports